export default __webpack_public_path__ + "static/media/responsivex1cric.db810874.png";